module.exports = require('../../full/object/get-prototype-of');
